<template>
  <div v-if="!showRequest">
    <app-history @clicked="$router.push('/change-picture-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        چنانچه قصد تغيير تصوير خود در پرتال را داريد، مي توانيد فايل تصوير خود
        را در اين بخش ارسال فرمائيد، تصوير شما بعد از تائيد (توسط واحد پذيرش) در
        پرتال قرار خواهد گرفت.
        <br />
        شما در بخش مشاهده سوابق قادر خواهيد بود درخواست خود مبني بر تغيير تصوير
        را پيگيري فرمائيد
        <br />
        نوع فايل مي بايست از اواع فايل هاي تصويري باشد، نظير jpg,png,bmp
        <br />
        <br />
        <h3>شرايط عكس معمم:</h3>
        <br />

        <ol>
          <li>اتمام سطح يك</li>
          <li>عكس به صورت 4*3 تمام رخ و بدون پشت زمينه</li>
          <li>
            عمامه در عكس با زمينه سفيد يا آبي كم رنگ و يا خاكستري كم رنگ و يا
            كرمي ديد ندارد ،زمينه عكس تيره باشد.
          </li>
          <li>پيراهن یقه طلبگي و با زمينه رنگ تيره</li>
          <li>
            لباس بدون چهارخانه و بدون كادر اضافه و با كيفيت بالا ارسال شود.
          </li>
        </ol>
        <br />

        <h3>شرايط عكس شخصي ویژه برادران:</h3>
        <br />

        <ol>
          <li>عكس به صورت 4*3 تمام رخ و بدون پشت زمينه</li>
          <li>پيراهن یقه طلبگي و با زمينه رنگ تيره</li>

          <li>
            لباس بدون چهارخانه و بدون كادر اضافه و با كيفيت بالا ارسال شود.
          </li>
        </ol>
        <br />
        <h3>شرايط عكس شخصي ویژه خواهران:</h3>
        <br />

        <ol>
          <li>
            اسكن عكس پرسنلي وغيرپاسپورتي درابعاد 4*3 تمام رخ و بازمينه سفيد
          </li>
          <li>بدون عينك</li>

          <li>چادرمشكي وبدون كادراضافه وباكيفيت بالاو شفاف</li>
        </ol>
        <br />
      </div>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="request" rounded @click="handleShowRequest">
          درخواست تغییر تصویر
        </v-btn>
      </v-row>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input label="فايل تصوير جديد" v-model="image"></v-file-input>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest" :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { requestChangePicture } from "@/api/picture";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {
      showRequest: false,
      image: null,
      comment: "",
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    applyRequest() {
      var text = "";
      if (this.image == null) {
        text = "ارسال تصویر ضروری می باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        requestChangePicture(this.image, this.comment)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }
  },

  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }

  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;

    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
